/* eslint-disable @nx/enforce-module-boundaries */
import { createSelector } from '@ngrx/store';

import { UserViewModel } from '@ninety/mobile/platform/api';

import { CompanyUserListModel } from '../../../app-entities/company-users/company-users-state.model';
import { CompanyUserSelectors } from '../../../app-entities/company-users/company-users-state.selectors';
import { CurrentUserSelectors } from '../../../app-entities/user-list/user-list-state.selectors';
import { CurrentPersonStateModel } from '../../current-person/current-person-state.model';
import { selectCurrentPersonState } from '../../current-person/current-person-state.selectors';

export const selectGainsightUserAttributes = createSelector(
  [
    selectCurrentPersonState,
    CompanyUserSelectors.selectCurrentCompanyUser,
    CompanyUserSelectors.selectCurrentCompanySltTeamId,
    CurrentUserSelectors.selectUser,
  ],
  (
    cp: CurrentPersonStateModel,
    cu: CompanyUserListModel | null,
    sltTeamId: string | undefined,
    currentUser: UserViewModel | null
  ) => ({
    accountId: cu?.companyId,
    personIsImplementer: cp.person?.isImplementer,
    currentUserRoleName: currentUser?.roleName,
    currentUserRoleCode: currentUser?.roleCode,
    userIsImplementer: currentUser?.isImplementer,
    currentPersonId: cp.person?._id,
    currentUserCompany: cu?.companyName,
    currentUserCompanyBos: cu?.bos,
    isLeadership: currentUser?.teams?.find(t => t.teamId === sltTeamId) ? true : false,
  })
);

// export const selectTrackEventTraits = createSelector(
//   [
//     selectCurrentPersonState,
//     CompanyUserSelectors.selectCurrentCompanyUser,
//     CompanyUserSelectors.selectCurrentCompanySltTeamId,
//   ],
//   (
//     cp: CurrentPersonStateModel,
//     cu: CompanyUserListModel | null,
//     sltTeamId: string | undefined,
//   ) => ({
//     ...cp,
//     ...cu,
//     isLeadership: sltTeamId === cu?.company?.seniorLeadershipTeamId,
//   })
// );
